import API from '../../services/api.svelte.js';
import { notificate } from '../../services/notification.js';
import { locale, format } from 'svelte-i18n';
import { get as getStore } from 'svelte/store';


// store Promise to avoid multiple simultaneous API calls
let assetsPromise;
let assets = [];

function setLocale(){
    let setLocale = getStore(locale);
    if(setLocale != "es" && setLocale != "en") setLocale = 'es';
    locale.set(setLocale);
}


export function search(resource = "v2/asset/", config = {filter: null, include_finding_count: false}) {
    assetsPromise = API.search(resource, config)
        .catch(() => {
            return [];
        })
        .then(pAssets => {
            assets = pAssets;
            return assets;
        })
    ;
    return assetsPromise;
}

export async function find(resource, id, config = {}) {
    let asset;
    return API.find('v2/' + resource, id, config)
        .catch(() => {
            return false;
        })
        .then(pAsset => {
            asset = pAsset;
            return asset;
        })
    ;
}

export async function save(data, files = [], config = {}, is_upsert = true) {
    return API.save('v2/asset', data, files, config, is_upsert)
        .then(async (response) => {
            if (!response.ok) {
                let errors = await response.json();
                // api validation errors
                if(response.status == 401){
                    notificate('limitReached')
                }
                else {
                    let toastConfig = {
                        data: data.name,
                        options : {
                            "timeOut": "0",
                            "extendedTimeOut": "0",
                            "showDuration": "0",
                            "hideDuration": "0",
                            "closeButton": true
                        }
                    }
                    if(config && config.massive_addition) toastConfig.error = errors;
                    notificate('save_error', "toast", toastConfig);
                }
                throw errors;
            }
            else {
                return response.json();
            }
        })
        .then(apiData => {
            //returns saved element to update table
            return apiData;
        })
    ;
}

export function del(asset_ids = [], config = {}) {
    setLocale();
    return API.del('v2/asset', asset_ids, config)
        .then(async (response) => {
            //if(!response.ok){
            if (response.status >= 400) {
                let toastConfig = {
                    data: getStore(format)("asset.word"),
                    options : {
                        "timeOut": "0",
                        "extendedTimeOut": "0",
                        "showDuration": "0",
                        "hideDuration": "0",
                        "closeButton": true
                    }
                }
                // api validation errors
                notificate('delete_error', "toast", toastConfig);
                throw await response.json();
            }
            else {
                notificate('delete_ok', "toast", {is_massive: asset_ids.length > 1 ? true : false, data: asset_ids.length > 1 ? getStore(format)("asset.plural") : getStore(format)("asset.word")});
                return true;
            }
        })
    ;
}


export function sortGroupedPorts(ports){
    ports = ports.sort((a,b)=>{
        let firstPortSplited = a[0] ? a[0].split("/") : a.split("/");
        let secondPortSplited = b[0] ? b[0].split("/"): b.split("/");
        let text_a = firstPortSplited[0];
        let text_b = secondPortSplited[0];
        let num_a = parseInt(firstPortSplited[1]);
        let num_b = parseInt(secondPortSplited[1]);
        return (text_a.localeCompare(text_b) == 0) ? (num_a > num_b) ? 1 : -1 : (text_a.localeCompare(text_b))
    });
    return ports;
}

export function is_ip_list(kind, checkKind){
    if(checkKind){
        return {
            private: kind.includes("private_ip"),
            public: kind.includes("public_ip"),
        }
    }
    return kind.includes("_ip");
};

export function is_hostname_list(kind){
    return kind.includes("hostname");
};

export function is_domain_list(kind){
   return kind.includes("domain");
}


const icons = {
    domain: 'fas fa-globe',
    hostname: 'fas fa-laptop-code',
    public_network: 'fas fa-network-wired',
    private_network: 'fas fa-ethernet',
    public_ip: 'fas fa-laptop',
    private_ip: 'fas fa-laptop-house',
    certificate: 'fas fa-lock',
    ad: 'fas fa-address-book',
    cloud: 'fas fa-cloud',
    software: 'fas fa-code-branch',
    endpoint: 'fas fa-project-diagram',
    email: 'fas fa-envelope',
    container_image: 'fab fa-docker',
}

const translations = {
    plural: {
        domain: 'Dominios',
        hostname: 'Hostnames',
        public_network: 'Redes públicas',
        private_network: 'Redes privadas',
        public_ip: 'Direcciones IP Públicas',
        private_ip: 'Direcciones IP Privadas',
        certificate: 'Certificados',
        ad: 'Active Directory',
        cloud: 'Cuentas cloud',
        software: 'Software',
        endpoint: 'Endpoint',
        email: 'Emails',
        container_image: 'Imágenes de contenedores'
    },
    singular: {
        domain: 'Dominio',
        hostname: 'Hostname',
        public_network: 'Red pública',
        private_network: 'Red privada',
        public_ip: 'IP Pública',
        private_ip: 'IP Privada',
        certificate: 'Certificado',
        ad: 'Active Directory',
        cloud: 'Cuenta cloud',
        software: 'Software',
        endpoint: 'Endpoint',
        email: 'Email',
        container_image: 'Imagen de contenedor',
    }
}

const known_kinds = [
    {id: "domain", name: "Dominio"},
    {id: "hostname", name: "Hostname"},
    {id: "public_network", name: "Red Pública"},
    {id: "private_network", name: "Red Privada"},
    {id: "public_ip", name: "IP pública"},
    {id: "private_ip", name: "IP privada"},
    {id: "ad", name: "Active Directory"},
    {id: "cloud", name: "Cuenta cloud"},
    {id: "software", name: "Software"},
    {id: "endpoint", name: "Endpoint"},
    {id: "email", name: "Email"},
    {id: "container_image", name: "Imagen de contenedor"},
]

const os_icons = [
    {label: "linux", fileName: "linux.png", height: "24"},
    {label: "microsoft", fileName: "microsoft.png", height: "24"},
    {label: "amazon", fileName: "amazon.png", height: "24"},
    {label: "vxworks", fileName: "vxworks.svg", height: "24"},
    {label: "paloalto", fileName: "paloalto.svg", height: "24"},
    {label: "vmware", fileName: "VMware.png", height: "24"},
    {label: "apple", fileName: "apple.png", height: "24"},
    {label: "cisco", fileName: "cisco.png", height: "24"},
    {label: "dell", fileName: "dell.png", height: "24"},
    {label: "fortinet", fileName: "fortinet.svg", height: "48"},
    {label: "hikvision", fileName: "hikvision.png", height: "24"},
    {label: "huawei", fileName: "huawei.png", height: "24"},
    {label: "mikrotik", fileName: "mikrotik.png", height: "24"},
    {label: "motorola", fileName: "motorola.png", height: "24"},
    {label: "unraid", fileName: "unraid.png", height: "24"},
    {label: "apc", fileName: "apc.svg", height: "24"},
    {label: "xerox", fileName: "xerox.png", height: "36"},
    {label: "samsung", fileName: "samsung.png", height: "16"},
    {label: "hp", fileName: "hp.png", height: "24"},
    {label: "extreme", fileName: "extreme.jpeg", height: "24"}

];

export default {
    search,
    find,
    save,
    del,
    sortGroupedPorts,
    is_domain_list,
    is_hostname_list,
    is_ip_list,
    icons,
    translations,
    known_kinds,
    os_icons
}